import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import Animation1 from "../../public/Animation/contract.json";
import Animation2 from "../../public/Animation/Idea.json";
import Animation3 from "../../public/Animation/Marking.json";
const Player = dynamic(
  () => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player),
  { ssr: false }
);

const items = [
  {
    title: "A Complete Guide to the All Exam Process",
    animation: Animation3,
    desc: `NEET PG Counselling 2026 is an important process for MBBS graduates who want to enter postgraduate courses like MD, MS, or PG Diploma. Since the exam is conducted once a year, understanding NEET PG Counselling, the NEET PG Counselling schedule, and the complete PG Counselling process is essential to choose your clinical or non-clinical specialty with confidence.`,
  },
  {
    title: "Who Conducts, Eligibility & Exam Significance",
    animation: Animation2,
    desc: `The exam is conducted by the National Board of Examinations (NBE). To appear for NEET PG, you must have completed your MBBS internship or be on track to finish it before the deadline. Your NEET PG score is crucial—it determines your chances of getting a seat in government, private, and deemed universities across India.`,
  },
  {
    title: "Overview of the Counselling Process",
    animation: Animation1,
    desc: `Once the results are released, the Medical Counselling Committee (MCC) manages the All India NEET PG Counselling for seats in government colleges, central institutes, and deemed universities. Meanwhile, each state runs its own counselling through State Counselling Authorities for state quota admissions. Your seat depends on your rank, the counselling body you participate in, and how well you plan your choices.`,
  },
];

export default function Overview() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
      <div className="text-center mb-10">
        <h2 className="text-2xl sm:text-3xl font-bold">NEET PG 2026 – Complete <span className="text-[#ff9245]">Complete Overview</span></h2>
        <p className="text-sm sm:text-lg text-gray-500 mt-2">Everything you need to know about NEET PG Counselling 2026 and how it shapes your medical career.</p>
      </div>

      <div className="space-y-16">
        {items.map((it, idx) => {
          const titleId = `overview-title-${idx}`;
          return (
            <article key={idx} aria-labelledby={titleId} className="flex flex-col lg:flex-row gap-8 items-center md:items-center lg:items-start">
              {/* Animation on Left */}
              <div className="flex-shrink-0 flex items-center justify-center lg:w-40">
                <div className="flex items-center justify-center w-36 h-36 rounded-2xl ">
                  {isClient && (
                    <Player
                      autoplay
                      loop
                      src={it.animation}
                      style={{ width: "140px", height: "140px" }}
                      aria-label={`${it.title} animation`}
                      role="img"
                    />
                  )}
                  {!isClient && (
                    <div className="w-24 h-24 bg-orange-200 rounded-full animate-pulse"></div>
                  )}
                </div>
              </div>

              {/* Content on Right */}
              <div className="flex-1 text-center lg:!text-left">
                <h3 id={titleId} className="text-lg sm:text-2xl font-bold text-gray-900 mb-4">
                  {it.title}
                </h3>
                <p className="leading-relaxed text-gray-600 text-md sm:text-base mb-4">{it.desc}</p>

                {/* {idx === 2 && (
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-1 font-bold">•</span>
                      <span>Medical Counselling Committee (MCC) conducts counselling for Seat across all India under Government Institutes, Deemed and Central Institutions</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-1 font-bold">•</span>
                      <span>State counselling authorities manage counselling for state quota seats.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-1 font-bold">•</span>
                      <span>The process includes choice filling, seat allotment, Joining at the allotted Institute. Counselling has Round 1, Round 2, Round 3 and Stray Round. Your admission depends on your rank, choice of subject, college preference, and category.</span>
                    </li>
                  </ul>
                )} */}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
